exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AlbumCover {\n  opacity: 0;\n  transition: opacity 0.15s;\n  background-color: #e2e4e6; }\n  .AlbumCover.is-loaded {\n    opacity: 1; }\n", ""]);

// exports
